module.exports = __webpack_public_path__ + "img/85.6e495cb9.svg";